import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharingDataService } from '../../../shared/services/sharingData/sharing-data.service';
import { ValidationService } from 'src/shared/services/validation/validation.service';
import { ConfigData } from '../../models/configData.model';
import { CardService } from '../../../shared/services/card/card.service';
import { FormattingService } from 'src/shared/services/formatting/formatting.service';
import { Router, ActivatedRoute } from '@angular/router';
import { JsonResolved } from '../../models/jsonResolved.model';

@Component({
  selector: 'app-recommendation',
  templateUrl: './recommendation.component.html',
  styleUrls: ['./recommendation.component.css'],
})
export class RecommendationComponent implements OnInit {
  constructor(
    public sharingDataService: SharingDataService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private router: Router,
    private cardService: CardService,
    private formattingService: FormattingService,
    private route: ActivatedRoute
  ) {}

  nationality: string;
  configurations: ConfigData;
  recommendationsFormGroup: FormGroup;
  submitted: boolean = false;

  getConfigDetails() {
    this.configurations = this.cardService.getConfigInfo();
  }

  ngOnInit(): void {
    this.getConfigDetails();
    this.buildingForm();
    console.log(this.sharingDataService.minimumPaymtCalSharedData.Nationality);
    console.log(
      this.sharingDataService.minimumPaymtCalSharedData.TranslatedData
    );
  }

  buildingForm() {
    this.recommendationsFormGroup = this.formBuilder.group({
      NetIncomeTxBx: [
        '',
        [
          Validators.required,
          this.validationService.DesiredCreditLimitValidation(
            this.configurations.NetSalaryBoundaries.min,
            this.configurations.NetSalaryBoundaries.max
          ),
        ],
      ],
    });
    this.recommendationsFormGroup.controls.NetIncomeTxBx.valueChanges.subscribe(
      (change) => {
        let incomeVal = this.recommendationsFormGroup.controls.NetIncomeTxBx
          .value;
        let unwantedContentRemovedValue = incomeVal.replace(/[^0-9,.]/g, '');
        if (change != unwantedContentRemovedValue) {
          this.recommendationsFormGroup.controls.NetIncomeTxBx.setValue(
            unwantedContentRemovedValue
          );
        }
      }
    );
  }

  setSaudi() {
    this.sharingDataService.minimumPaymtCalSharedData.Nationality = true;
  }

  setNonSaudi() {
    this.sharingDataService.minimumPaymtCalSharedData.Nationality = false;
  }

  NetIncomeTxBx_Blur(event: any) {
    let value = event.target.value;
    let removeFormattedValue = this.formattingService.removeFormattedCurrency(
      value
    );
    let formattedValue = this.formattingService.formatCurrency(
      removeFormattedValue
    );
    this.recommendationsFormGroup.get('NetIncomeTxBx').setValue(formattedValue);
  }

  proceed() {
    this.submitted = true;
    this.sharingDataService.minimumPaymtCalSharedData.MonthlyIncome = this.recommendationsFormGroup.get(
      'NetIncomeTxBx'
    ).value;
    this.router.navigate(['/cardrecommendation']);
  }
}
